module.exports = __webpack_public_path__ + "img/wallet-danger.51a9dba0.svg";